module.exports = require('./cjs');


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-forward/index.js
// module id = 455
// module chunks = 6